import { render, staticRenderFns } from "./StandardWrappingReorderable.vue?vue&type=template&id=035973bc&scoped=true&"
import script from "./StandardWrappingReorderable.vue?vue&type=script&lang=ts&"
export * from "./StandardWrappingReorderable.vue?vue&type=script&lang=ts&"
import style0 from "./StandardWrappingReorderable.vue?vue&type=style&index=0&id=035973bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035973bc",
  null
  
)

export default component.exports